"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_tokens_json_1 = __importDefault(require("../tokens/b2b/colors.tokens.json"));

var space_tokens_json_1 = __importDefault(require("../tokens/b2b/space.tokens.json"));

var breakpoints_tokens_json_1 = __importDefault(require("../tokens/b2b/breakpoints.tokens.json"));

var buttons_tokens_json_1 = __importDefault(require("../tokens/b2b/buttons.tokens.json"));

var elevations_tokens_json_1 = __importDefault(require("../tokens/b2b/elevations.tokens.json"));

var fontFamilies_tokens_json_1 = __importDefault(require("../tokens/b2b/fontFamilies.tokens.json"));

var fontSizes_tokens_json_1 = __importDefault(require("../tokens/b2b/fontSizes.tokens.json"));

var lineHeights_tokens_json_1 = __importDefault(require("../tokens/b2b/lineHeights.tokens.json"));

var fontWeights_tokens_json_1 = __importDefault(require("../tokens/b2b/fontWeights.tokens.json"));

var radii_tokens_json_1 = __importDefault(require("../tokens/b2b/radii.tokens.json"));

var borders_tokens_json_1 = __importDefault(require("../tokens/b2b/borders.tokens.json"));

var grid_tokens_json_1 = __importDefault(require("../tokens/b2b/grid.tokens.json"));

var internal_tokens_json_1 = __importDefault(require("../tokens/b2b/internal.tokens.json"));

var theme = {
  colors: colors_tokens_json_1.default,
  space: space_tokens_json_1.default,
  breakpoints: breakpoints_tokens_json_1.default,
  buttons: buttons_tokens_json_1.default,
  elevations: elevations_tokens_json_1.default,
  fontFamilies: fontFamilies_tokens_json_1.default,
  fontSizes: fontSizes_tokens_json_1.default,
  lineHeights: lineHeights_tokens_json_1.default,
  fontWeights: fontWeights_tokens_json_1.default,
  radii: radii_tokens_json_1.default,
  borders: borders_tokens_json_1.default,
  internal: internal_tokens_json_1.default,
  grid: grid_tokens_json_1.default
};
exports.default = theme;